var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Checkbox - Off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.8458278,2 L18.1541722,2 C19.4914503,2 19.9763797,2.13923842 20.4652686,2.40069906 C20.9541574,2.66215969 21.3378403,3.04584256 21.5993009,3.53473144 C21.8607616,4.02362033 22,4.50854969 22,5.8458278 L22,18.1541722 C22,19.4914503 21.8607616,19.9763797 21.5993009,20.4652686 C21.3378403,20.9541574 20.9541574,21.3378403 20.4652686,21.5993009 C19.9763797,21.8607616 19.4914503,22 18.1541722,22 L5.8458278,22 C4.50854969,22 4.02362033,21.8607616 3.53473144,21.5993009 C3.04584256,21.3378403 2.66215969,20.9541574 2.40069906,20.4652686 C2.13923842,19.9763797 2,19.4914503 2,18.1541722 L2,5.8458278 C2,4.50854969 2.13923842,4.02362033 2.40069906,3.53473144 C2.66215969,3.04584256 3.04584256,2.66215969 3.53473144,2.40069906 C4.02362033,2.13923842 4.50854969,2 5.8458278,2 Z M6.5638852,4 C5.67236646,4 5.34908022,4.09282561 5.0231543,4.2671327 C4.69722837,4.4414398 4.4414398,4.69722837 4.2671327,5.0231543 C4.09282561,5.34908022 4,5.67236646 4,6.5638852 L4,17.4361148 C4,18.3276335 4.09282561,18.6509198 4.2671327,18.9768457 C4.4414398,19.3027716 4.69722837,19.5585602 5.0231543,19.7328673 C5.34908022,19.9071744 5.67236646,20 6.5638852,20 L17.4361148,20 C18.3276335,20 18.6509198,19.9071744 18.9768457,19.7328673 C19.3027716,19.5585602 19.5585602,19.3027716 19.7328673,18.9768457 C19.9071744,18.6509198 20,18.3276335 20,17.4361148 L20,6.5638852 C20,5.67236646 19.9071744,5.34908022 19.7328673,5.0231543 C19.5585602,4.69722837 19.3027716,4.4414398 18.9768457,4.2671327 C18.6509198,4.09282561 18.3276335,4 17.4361148,4 L6.5638852,4 Z",
    id: "path-1-checkbox-off"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Checkbox---Off",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-checkbox-off",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-checkbox-off"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mixin/Fill/Black",
    mask: "url(#mask-2-checkbox-off)",
    fill: "#00242D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOff);
export default __webpack_public_path__ + "static/media/Checkbox-Off.9658ad60.svg";
export { ForwardRef as ReactComponent };